import { render, staticRenderFns } from "./index-news.vue?vue&type=template&id=08b640cc&scoped=true&"
import script from "./index-news.vue?vue&type=script&lang=js&"
export * from "./index-news.vue?vue&type=script&lang=js&"
import style0 from "./index-news.vue?vue&type=style&index=0&id=08b640cc&lang=less&scoped=true&"
import style1 from "./index-news.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b640cc",
  null
  
)

export default component.exports